<template lang="pug">
  div.d-flex.justify-center.align-center(style="height: 100%")
    vue-qrcode(:value="link" :options="{ width: 300 }")
</template>

<script>
import VueQrcode from '@chenfengyuan/vue-qrcode'
export default {
  name: 'PrintQrCode',
  components: { VueQrcode },
  data () {
    return {
      link: 'https://yezza.com'
    }
  },
  mounted () {
    if (this.$route.query.link) {
      this.link = this.$route.query.link
    }
  }
}
</script>